import React, { useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import Logo from "../../components/Logo";
import { data } from "../../data/data";
import {useTranslation} from "react-i18next";

export const Message = ({ type, reason }: {type: string, reason: string}) => {
  let msg, img;
  const { t } = useTranslation();
  switch (type) {
    case "pending":
      msg = <span>{t("Your order has been received! Payment completion pending.")}</span>;
      img = "success";
      break;
    case "failed":
      msg = <span>{t("The payment was refused. Please try a different payment method or card.")}</span>;
      img = "failed";
      break;
    case "error":
      msg = (
        <span>
          {t("Error")} {t(reason || "Internal error")}
        </span>
      );
      img = "failed";
      break;
    default:
      msg = <span>{t("Your order has been successfully placed.")}</span>;
      img = "success";
  }

  return (
    <>
      <img src={`/images/${img}.svg`} className="status-image" alt={img} />
      <p className="status-message">{msg}</p>
    </>
  );
};

export const StatusContainer = () => {
  const {t} = useTranslation();
  let { type } = useParams();
  let query = new URLSearchParams(useLocation().search);
  let reason = query ? query.get("reason") : "";
  
  useEffect(() => {
    setTimeout(() => {
      if (data.redirectUrl) {
        window.location.replace(data.redirectUrl);
      }
    }, 4000);
  });

  return (
    <div className="main-container">
      <div className="outer">
        <Logo />
        <div className="inner">
          <Message type={type || ""} reason={reason || ""} />
          {data.redirectUrl && <b>{t('Redirecting …')}</b>}
        </div>
      </div>
    </div>
  );
}
